'use client';
import { queryKeys } from '@/lib/query-keys';
import { apiClient } from '@borradh-workspace/api-client';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { toast } from 'sonner';

export function useSendAppointmentForms(appointmentId: string) {
  const queryClient = useQueryClient();
  const mutation = useMutation({
    mutationFn: () =>
      apiClient.post<{ sent: number }>(
        `consent-form-templates/submissions/appointment/${encodeURIComponent(appointmentId)}/send`,
        {}
      ),
    onSuccess: () => {
      void queryClient.invalidateQueries({
        queryKey:
          queryKeys.consentFormSubmissions.forAppointment(appointmentId),
      });
      void queryClient.invalidateQueries({ queryKey: queryKeys.leads.all() });
      toast.success('Form email sent');
    },
    onError: (error: Error) =>
      toast.error(error.message || 'Could not send forms. Try again.'),
  });
  return { sendForms: mutation.mutate, isSending: mutation.isPending };
}
